import React, { memo, useRef, useState } from 'react';
import {
  CloseWrapper,
  Error,
  ErrorMessageText,
  ErrorText,
  ErrorText1,
  MediaContainer,
  PlayIconWrapper,
  ProgressContainer,
  ProgressContent,
  SkeletonContainer,
} from './MediaItem.styles';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { ReactComponent as PlayIcon } from '../../assets/icons/play-white.svg';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import { ALBUM_MEDIA_TYPE, UPLOAD_FILE_CONSTRAINTS, UPLOAD_MEDIA_FILE_ERROR_TYPE } from '../../utils/constants';

const MediaItem = ({ file, progress, onDelete, type, uploadError, onClick, kind }) => {
  const [loaded, setLoaded] = useState(false);

  const handleMediaLoaded = () => {
    setLoaded(true);
  };

  const ERROR_MESSAGES = {
    [UPLOAD_MEDIA_FILE_ERROR_TYPE.FILE_SIZE]: `File size is too large (max ${UPLOAD_FILE_CONSTRAINTS[type].MAX_SIZE_IN_MB}MB)`,
    [UPLOAD_MEDIA_FILE_ERROR_TYPE.FILE_TYPE]: `Invalid file type (allowed: ${UPLOAD_FILE_CONSTRAINTS[type].ALLOWED_EXTENSIONS_TEXT})`,
  };

  const videoRef = useRef(null);

  const handleLoadedMetadata = async () => {
    const video = videoRef.current;

    try {
      if (video) {
        await video.play();
        setTimeout(async () => {
          await video.pause();
        }, 100);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const renderContent = () => {
    switch (type) {
      case UPLOAD_FILE_CONSTRAINTS.TYPE.PHOTO:
        return <img src={file.url} alt="influencer-image" onLoad={handleMediaLoaded} />;
      case UPLOAD_FILE_CONSTRAINTS.TYPE.VIDEO:
        return (
          <video
            ref={videoRef}
            muted
            playsInline
            preload="auto"
            autoPlay={false}
            src={file.url}
            onLoadedMetadata={handleLoadedMetadata}
            onLoadedData={handleMediaLoaded}
          />
        );
      case UPLOAD_FILE_CONSTRAINTS.TYPE.STORY:
        return <img src={file.url} alt="influencer-image" onLoad={handleMediaLoaded} />;
      default:
        break;
    }
  };
  return (
    <MediaContainer onClick={onClick} $cursor={!!onClick}>
      {progress ? (
        <ProgressContainer>
          <ProgressContent>
            <CircularProgressbar
              value={progress}
              text={`${progress}%`}
              styles={buildStyles({
                pathColor: '#61ADE9',
                textColor: '#fff',
                trailColor: '#FFFFFF45',
              })}
            />
          </ProgressContent>
        </ProgressContainer>
      ) : (
        <>
          {onDelete && (
            <CloseWrapper onClick={onDelete}>
              <CloseIcon width={14} height={14} color="#fff" />
            </CloseWrapper>
          )}
        </>
      )}
      {!loaded && <SkeletonContainer />}
      {kind === ALBUM_MEDIA_TYPE.VIDEO && onClick && (
        <PlayIconWrapper>
          <PlayIcon fill="white" />
        </PlayIconWrapper>
      )}
      {renderContent()}
      {uploadError && (
        <Error>
          <ErrorText>Upload Failed</ErrorText>
          <ErrorMessageText>{ERROR_MESSAGES[uploadError.type]}</ErrorMessageText>
          <ErrorText1>Please try again.</ErrorText1>
        </Error>
      )}
    </MediaContainer>
  );
};

export default memo(MediaItem);
